import React from "react";

import '../styles/pages/Home.css';

import Footer from "../components/Footer"

import Button from "../components/Button";

import profilePic from '../assets/pfp.png';
import album1Pic from '../assets/album1Pic.png';



function Home()
{

    return(
        <div className="fullscreen-div">
            <div className="homeContent">
                <div className="pfpContainer">
                    <img className="pfp" src={profilePic}></img>

                    <div className="textGrid">
                        <h1 className="title">Andrea Brunori</h1>
                        <p className="paragraph">
                        Andrea Brunori is a solo musician, that composes, arranges and mixes his songs.
                        His genre is a unique mix of Symphonic, Power and Prog Metal with influxes by many different genres,
                        and his songs often shift from a genre and a sound to another completely different.
                        His recent releases are part of a project that comprises songs inspired by poems of the Romantic Period.  
                        </p>
                    </div>

                </div>

                <div className="album1Container">

                    <img className="album1Pic" src={album1Pic}></img>
                    
                    <div className="textGrid">
                        <h1 className="title">...about Love, Death and Despair</h1>
                        <p className="paragraph">
                        "...about Love, Death and Despair" is the very first EP made by Andrea Brunori, It is composed of the following tracks: 
                        "La Belle Dame Sans Merci", "It Was Not Death (For I Stood Up)" and "Lenore". <br></br> Songs in this album are poems from the
                        past who gained new life by becoming songs.
                        </p>
                        <Button className="playNowButton" image="/publicAssets/spotifyLogo.png" style="primary" text="Listen now" link='https://open.spotify.com/intl-it/artist/1EwVwRAxMwa468Lxfl4Gbx?si=KKvTLmvuSnCqztyXt0E_ng'></Button>
                    </div>

                    
                    
                </div>
            </div>
        <Footer></Footer>   
        </div>
    );
}

export default Home;